<nav
  class="navbar navbar-top navbar-expand navbar-dark bg-danger border-bottom"
  id="navbar-main"
  >
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <!-- Navbar links -->
      <ul class="navbar-nav align-items-center ml-md-auto">
        <li class="nav-item d-xl-none">
          <!-- Sidenav toggler -->
          <div
            class="pr-3 sidenav-toggler sidenav-toggler-dark"
            data-action="sidenav-pin"
            data-target="#sidenav-main"
            (click)="openSidebar()"
            >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
      </ul>
      <!-- User -->
      <ul class="navbar-nav align-items-center ml-auto ml-md-0">
        <li class="nav-item dropdown" dropdown placement="bottom-right">
          <a class="nav-link pr-0 dropdown-toggle" role="button" dropdownToggle>
            <div class="media align-items-center">
              <img src="assets/img/ieeg/logoSEL.png" width="25" height="20"/>
              <!-- <span class="avatar avatar-sm rounded-circle">
              <img [src]="photoProfile | imagenProfile" alt="User image" />
            </span> -->
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{
                sesionUsuario?.name
              }}</span>
            </div>
          </div>
        </a>
        <div
          class="dropdown-menu dropdown-menu-arrow dropdown-menu-right"
          *dropdownMenu
          >
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">¡Bienvenido!</h6>
          </div>

          @if (allowedUserRol()) {
            <a class="dropdown-item">
              <i class="fas fa-id-card"></i>
              <span>N° Empleado: {{ sesionUsuario?.idEmpleado }}</span>
            </a>
          }
          <!--
          <a
            class="dropdown-item"
            routerLink="/admin/usuario"
            *ngIf="allowedUserRol()"
            >
            <i class="fa-solid fa-user"></i> <span>Mi perfil</span>
          </a> -->

          <div class="dropdown-divider"></div>

          @if (allowedUserRol()) {
            <a
              href="javascript:void()"
              (click)="logout()"
              class="dropdown-item"
              >
              <i class="fas fa-sign-out-alt"></i> <span>Cerrar sesión</span>
            </a>
          }

          @if (aspiranteLogueado) {
            <a
              href="javascript:void()"
              (click)="logoutAspirante()"
              class="dropdown-item"
              >
              <i class="fas fa-sign-out-alt"></i> <span>Cerrar sesión</span>
            </a>
          }
        </div>
      </li>
    </ul>
  </div>
</div>
</nav>
@if (sidenavOpen === true) {
  <div
    class="backdrop d-xl-none"
    (click)="toggleSidenav()"
  ></div>
}
